import { HttpErrorResponse } from '@angular/common/http';
import { NavigationExtras, Params, Router, UrlTree } from '@angular/router';
import { Observable, throwError as observableThrowError, of } from 'rxjs';

import { Exception } from '®shared/errors';

export const DEFAULT_NAVIGATION_EXTRAS: NavigationExtras = {
  preserveFragment: true,
  queryParamsHandling: 'merge',
  replaceUrl: true,
  skipLocationChange: true,
};

export function getErrorPageQueryParams(
  code: number | null = null,
  title: string | null = null,
  detail: string | null = null,
): Params {
  return { code, title, detail };
}

export function getErrorPageQueryParamsForHttpErrorResponse(
  error: HttpErrorResponse,
): Params {
  const { message, status, statusText } = error;
  return getErrorPageQueryParams(status, statusText, message);
}

export function getNavigationExtrasForHttpErrorResponse(
  error: HttpErrorResponse,
  defaults: NavigationExtras = DEFAULT_NAVIGATION_EXTRAS,
): NavigationExtras {
  const queryParams = getErrorPageQueryParamsForHttpErrorResponse(error);
  return { ...defaults, queryParams };
}

export function getErrorPageQueryParamsForException(
  exception: Exception,
): Params {
  const { message, status, statusText } = exception;
  return getErrorPageQueryParams(status, statusText, message);
}

export function getNavigationExtrasForException(
  exception: Exception,
  defaults: NavigationExtras = DEFAULT_NAVIGATION_EXTRAS,
): NavigationExtras {
  const queryParams = getErrorPageQueryParamsForException(exception);
  return { ...defaults, queryParams };
}

export function getNavigationExtrasForError(
  code: number | null = null,
  title: string | null = null,
  detail: string | null = null,
  defaults: NavigationExtras = DEFAULT_NAVIGATION_EXTRAS,
): NavigationExtras {
  const queryParams = getErrorPageQueryParams(code, title, detail);
  return { ...defaults, queryParams };
}

export function handleRenavigationError(router: Router) {
  return (error: any): Observable<any> => {
    if (error instanceof HttpErrorResponse || error instanceof Exception) {
      router.navigate(['error'], getNavigationExtras(error));
    }

    return observableThrowError(error);
  };
}

export function canActivateErrorHandler(router: Router) {
  return (error: any): Observable<boolean | UrlTree> => {
    const urlTree = router.createUrlTree(['error'], getNavigationExtras(error));
    return of(urlTree);
  };
}

function getNavigationExtras(error: any): NavigationExtras | undefined {
  if (error instanceof HttpErrorResponse) {
    return getNavigationExtrasForHttpErrorResponse(error);
  } else if (error instanceof Exception) {
    return getNavigationExtrasForException(error);
  }
  return undefined;
}
